// extracted by mini-css-extract-plugin
module.exports = {"cta-container":"markdown-docs-cta_cta-container__FwTwm","cta":"markdown-docs-cta_cta__J1hjM"};